import Skeleton from "@material-ui/core/Skeleton";
import Typography from "@material-ui/core/Typography";
import { ArrowDropDownTwoTone, ArrowDropUpTwoTone } from "@material-ui/icons";
import React from "react";
import numberFormat from "../../../../utils/formatNumber";
import { DynamicPastPeriodFC } from "./types";

const dinamicToIcon = (dinamicValue: number): React.ElementType => {
  if (dinamicValue > 0) {
    return ArrowDropUpTwoTone;
  }
  return ArrowDropDownTwoTone;
};

const dinamicToColor = (dinamicValue: number): string => {
  if (dinamicValue > 0) {
    return "success.main";
  }
  return "error.main";
};
const plusOrMinus = (value: number | undefined): "+" | "-" | "" => {
  if (!value) {
    return "";
  }
  if (value > 0) {
    return "+";
  } else if (value < 0) {
    return "-";
  }
  return "";
};

const DynamicPastPeriod: DynamicPastPeriodFC = ({ value = 0, isLoading }) => {
  if (Math.abs(value) === 0 && isLoading === false) {
    return null;
  }
  let valueNode: React.ReactNode;
  let DinamicIcon: React.ElementType | null = null;
  if (isLoading) {
    valueNode = (
      <Skeleton width={30} sx={{ display: "inline-block", mr: 0.5 }} />
    );
  } else {
    valueNode = plusOrMinus(value) + numberFormat(Math.abs(value), 0);
    DinamicIcon = dinamicToIcon(value);
  }
  return (
    <Typography variant={"subtitle2"} noWrap sx={{ flexShrink: 0 }}>
      {DinamicIcon ? (
        <DinamicIcon
          sx={{ color: dinamicToColor(value), verticalAlign: "bottom" }}
        />
      ) : null}
      {valueNode}
      {"%"}
    </Typography>
  );
};

export default DynamicPastPeriod;
